import React, {Component} from 'react';
import SizeGuide from './SizeGuide';
import VariantSelector from './VariantSelector';

class Product extends Component {
  constructor(props) {
    super(props);

    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(event) {
    const variantId = event.target.value
    const quantity = 1
    this.props.addVariantToCart(variantId, quantity)
  }

  render() {
    let imageClass = "image_count_0" + this.props.product.images.length
    let variantImages = this.props.product.images.map((image) => {
      return (
        <img
          src={image.src}
          alt={`${this.props.product.title} product shot`}
          key={image.id.toString()}
        />
      );
    });
    let variantSelectors = this.props.product.variants.map((variant) => {
      return (
        <VariantSelector
          handleOptionChange={this.handleOptionChange}
          key={variant.id.toString()}
          variant={variant}
        />
      );
    });
    return (
      <div className="Product">
        <p><b><font face="times"size="2" color="blue">{this.props.product.title}</font></b></p>
        <div className="Product__image_container">
          <div className={`Product__images ${imageClass}`}>
            {variantImages}
          </div>
        </div>
        <div className="Product__option">
          {variantSelectors}
        </div>
        {this.props.product.productType && <SizeGuide productType={this.props.product.productType} />}
      </div>
    );
  }
}

export default Product;
